module.exports = __webpack_public_path__ + "static/venmo@2x-8378ee57075ca0a3e082c99794ea751e.png";